"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.adjustClientRectForOffset = exports.TooltipPositionInfoMap = exports.TooltipPosition = exports.TooltipStyleName = exports.TooltipThemeContext = exports.AggregateTooltipPadding = exports.AnchorClientRectPadding = exports.DefaultMaxWidth = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var TypeStyle = tslib_1.__importStar(require("typestyle"));
var TabStyles_1 = require("../../styles/TabStyles");
var Overlay_1 = require("../../utils/Overlay");
exports.DefaultMaxWidth = 300;
/** This is padding between the anchor client rect boundary and the tooltip overlay boundary. */
exports.AnchorClientRectPadding = 6;
var BorderWidth = 1;
var Padding = 12;
exports.AggregateTooltipPadding = 2 * (BorderWidth + Padding);
/** @deprecated This is intended for use only by Tableau Pulse. Please contact #tab-dev-shared-widgets if you need it in another place. */
exports.TooltipThemeContext = React.createContext({});
var TooltipStyle = {
    backgroundColor: 'white',
    border: BorderWidth + "px solid #d4d4d4",
    borderRadius: 1,
    boxShadow: TabStyles_1.TabStyles.Shadow.Elevated,
    boxSizing: 'border-box',
    display: 'block',
    fontSize: 12,
    lineHeight: 'normal',
    padding: Padding,
};
exports.TooltipStyleName = TypeStyle.style(TooltipStyle);
var TooltipPosition;
(function (TooltipPosition) {
    TooltipPosition["TopLeftCorner"] = "TopLeftCorner";
    TooltipPosition["Top"] = "Top";
    TooltipPosition["TopRightCorner"] = "TopRightCorner";
    TooltipPosition["Right"] = "Right";
    TooltipPosition["BottomRightCorner"] = "BottomRightCorner";
    TooltipPosition["Bottom"] = "Bottom";
    TooltipPosition["BottomLeftCorner"] = "BottomLeftCorner";
    TooltipPosition["Left"] = "Left";
})(TooltipPosition = exports.TooltipPosition || (exports.TooltipPosition = {}));
exports.TooltipPositionInfoMap = (_a = {},
    _a[TooltipPosition.TopLeftCorner] = {
        anchorOrigin: { horizontal: Overlay_1.HorizontalOriginOption.left, vertical: Overlay_1.VerticalOriginOption.top },
        stackedOrigin: { horizontal: Overlay_1.HorizontalOriginOption.right, vertical: Overlay_1.VerticalOriginOption.bottom },
    },
    _a[TooltipPosition.Top] = {
        anchorOrigin: { horizontal: Overlay_1.HorizontalOriginOption.centerX, vertical: Overlay_1.VerticalOriginOption.top },
        stackedOrigin: { horizontal: Overlay_1.HorizontalOriginOption.centerX, vertical: Overlay_1.VerticalOriginOption.bottom },
    },
    _a[TooltipPosition.TopRightCorner] = {
        anchorOrigin: { horizontal: Overlay_1.HorizontalOriginOption.right, vertical: Overlay_1.VerticalOriginOption.top },
        stackedOrigin: { horizontal: Overlay_1.HorizontalOriginOption.left, vertical: Overlay_1.VerticalOriginOption.bottom },
    },
    _a[TooltipPosition.Right] = {
        anchorOrigin: { horizontal: Overlay_1.HorizontalOriginOption.right, vertical: Overlay_1.VerticalOriginOption.centerY },
        stackedOrigin: { horizontal: Overlay_1.HorizontalOriginOption.left, vertical: Overlay_1.VerticalOriginOption.centerY },
    },
    _a[TooltipPosition.BottomRightCorner] = {
        anchorOrigin: { horizontal: Overlay_1.HorizontalOriginOption.right, vertical: Overlay_1.VerticalOriginOption.bottom },
        stackedOrigin: { horizontal: Overlay_1.HorizontalOriginOption.left, vertical: Overlay_1.VerticalOriginOption.top },
    },
    _a[TooltipPosition.Bottom] = {
        anchorOrigin: { horizontal: Overlay_1.HorizontalOriginOption.centerX, vertical: Overlay_1.VerticalOriginOption.bottom },
        stackedOrigin: { horizontal: Overlay_1.HorizontalOriginOption.centerX, vertical: Overlay_1.VerticalOriginOption.top },
    },
    _a[TooltipPosition.BottomLeftCorner] = {
        anchorOrigin: { horizontal: Overlay_1.HorizontalOriginOption.left, vertical: Overlay_1.VerticalOriginOption.bottom },
        stackedOrigin: { horizontal: Overlay_1.HorizontalOriginOption.right, vertical: Overlay_1.VerticalOriginOption.top },
    },
    _a[TooltipPosition.Left] = {
        anchorOrigin: { horizontal: Overlay_1.HorizontalOriginOption.left, vertical: Overlay_1.VerticalOriginOption.centerY },
        stackedOrigin: { horizontal: Overlay_1.HorizontalOriginOption.right, vertical: Overlay_1.VerticalOriginOption.centerY },
    },
    _a);
function adjustClientRectForOffset(clientRect) {
    return {
        bottom: clientRect.bottom + exports.AnchorClientRectPadding,
        // 2 * AnchorClientRectPadding accounts for the left and right offsets of AnchorClientRectPadding
        height: clientRect.height + (2 * exports.AnchorClientRectPadding),
        left: clientRect.left - exports.AnchorClientRectPadding,
        right: clientRect.right + exports.AnchorClientRectPadding,
        top: clientRect.top - exports.AnchorClientRectPadding,
        // 2 * AnchorClientRectPadding accounts for the top and bottom offsets of AnchorClientRectPadding
        width: clientRect.width + (2 * exports.AnchorClientRectPadding),
    };
}
exports.adjustClientRectForOffset = adjustClientRectForOffset;
//# sourceMappingURL=TooltipConsts.js.map